// extracted by css-extract-rspack-plugin
export default {"ExpressionListItem":"A3yyq","isHighlighted":"HTC6K","ExpressionListFooter":"bSv2F","GroupTitle":"OGZyH","PopoverHoverTarget":"o5ori"};